export default __webpack_public_path__ + "img/5cbbdee64ada888539b09811880df52b.png";